/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".remove-rfc-dialog[_ngcontent-%COMP%]{width:450px}.remove-rfc-dialog-content[_ngcontent-%COMP%]{margin-top:16px}.remove-rfc-dialog-actionbar[_ngcontent-%COMP%]{justify-content:flex-end}"];
export { styles as styles };

